import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-auto-particuliers',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-auto-particuliers.component.html',
  styleUrl: './assurance-auto-particuliers.component.scss'
})
export class AssuranceAutoParticuliersComponent {
  title = 'Assurance Auto Personnelle';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/auto-peso.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Auto', link: undefined }
  ];

  prevPage = { title: 'Assurance Prévoyance Particuliers',
    link: '/assurance-prevoyance-particuliers' // ✅ Corrigé
  };

  nextPage = { title: 'Assurance Santé Professionnels',
    link: '/assurance-sante-professionnels' // ✅ Ajouté next page
  };

  // Partners logos for carousel
  partners = [
    { name: 'Generali', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'April', logo: 'assets/images/logos/april-logo.png' },
    { name: 'Swiss Life', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Zephir', logo: 'assets/logos/zephir.png' },
    { name: 'Novelia', logo: 'assets/logos/novelia.png' },
    { name: 'FMA', logo: 'assets/logos/fma.png' },
    { name: 'Xenassur', logo: 'assets/logos/xenassur.png' },
  ];

  constructor(private router: Router) {}

  navigateToComparison() {
    this.router.navigate(['/cac/comparaison']);
  }
}
